import { type FC } from 'react'

import {
  nowBasicCheckRespGetSlotForCountdown,
  nowBasicCheckRespIsEligibleOrMinimumValueNotReached,
} from '../../../../now'
import { useProductPageContext } from '../../productPageContext'

import { ProductBuyBoxNowInfoCountdown } from './ProductBuyBoxNowInfoCountdown/ProductBuyBoxNowInfoCountdown'
import { ProductBuyBoxNowInfoDay } from './ProductBuyBoxNowInfoDay/ProductBuyBoxNowInfoDay'
import { ProductBuyBoxNowInfoSeeDetailsButton } from './ProductBuyBoxNowInfoSeeDetailsButton/ProductBuyBoxNowInfoSeeDetailsButton'

export const ProductBuyBoxNowInfo: FC = () => {
  const { nowDetails, product } = useProductPageContext()

  const nowDetailsForProduct =
    nowDetails.nowDataPerProduct[product.upid]?.responseData

  if (
    !nowBasicCheckRespIsEligibleOrMinimumValueNotReached(nowDetailsForProduct)
  ) {
    return null
  }

  const countDownSlot =
    nowDetailsForProduct &&
    nowBasicCheckRespGetSlotForCountdown(nowDetailsForProduct)

  if (!countDownSlot) {
    return null
  }

  return (
    <div className="w-full border-b border-dark-primary-min py-2.5">
      <ProductBuyBoxNowInfoDay nowSlot={countDownSlot} />
      <ProductBuyBoxNowInfoCountdown nowSlot={countDownSlot} />
      <ProductBuyBoxNowInfoSeeDetailsButton />
    </div>
  )
}
